import { TimelineMax, Elastic } from "gsap"

function DripAni() {

    function randomNumber(min, max) { 
        return Math.random() * (max - min) + min;
    }
    let paths = document.querySelectorAll(".hero-drip-svg path, .hero-drip-svg circle, .hero-drip-svg rect");
    if(paths !== undefined) {
        for(let x = 0; x < paths.length; x++) {
            let tl = new TimelineMax();
            //tl.fromTo(".drop-ani", .5, {x:'-140%'}, {x:"-5px", ease:Elastic.easeOut.config(.2,0.2)})
            //tl.fromTo(paths[x], randomNumber(6,8), {x:'-200%'}, {x:500, yoyo:true,ease:Elastic.easeOut.config(1.2,0.4)}, "-=.45");
			tl.fromTo(paths[x], randomNumber(6,7), {x:'-200%'}, {x:500, yoyo:true,ease:Elastic.easeOut.config(1.2,0.2)}, "-=.45");
            tl.delay(0.5);
        }
    }

    let pathsSmall = document.querySelectorAll(".drip-svg path");
    if(pathsSmall !== undefined) {
        for(let y = 0; y < pathsSmall.length; y++) {
            let tl3 = new TimelineMax();
            tl3.to(pathsSmall[y], 4,{x:randomNumber(-6, 6) + 0,yoyo:true,ease:Elastic.easeOut.config(1.5,0.2)})
            .to(pathsSmall[y], 4,{x:0,yoyo:true,ease:Elastic.easeOut.config(1.5,0.2)});
            tl3.repeat(-1);
        }
    }
}

export default DripAni;
